<template>
	<div class="components">
		<!-- <el-collapse v-model="componentKeys"> -->
		<!-- <a-collapse :defaultActiveKey="componentKeys" :bordered="false" expandIconPosition="right"> -->
		<!-- <a-collapse-panel v-for="group in data" :key="group.key" :header="group.name"> -->
		<!-- <el-collapse-item v-for="(group,index) in data" :key="index" :title="group.name" :name="index"> -->
		<div>
			<div v-for="(group, index) in data" :key="index" class="module_box">
				<div class="group_title">{{ group.name }}</div>
				<div class="module-list">
					<div v-for="(item, index) in group.data" :key="index" class="module-item"
						@click="handleClickItem(item.type,item.disable)">
						<!-- <object style="color: #f00;width: 30px;height: 30px;" :data="item.icon" type="image/svg+xml"></object> -->
						<img class="module-icon" :src="item.icon" alt="" srcset="" />
						<span class="module-title">{{ item.name }}</span>
						<!-- <img src="@/assets/page/icon/banner.png" alt="" /> -->
					</div>
				</div>
			</div>
		</div>

		<!-- </el-collapse-item> -->
		<!-- </el-collapse> -->
	</div>
</template>

<script>
	// import { filterModules } from '@/core/app'
	import * as Icon from "@/assets/icons/page/components";

	const data = [{
			name: "会员中心组件",
			key: "user",
			data: [{
					name: "会员信息",
					type: "userhead",
					icon: require("@/assets/page/icon/member.png"),
				},
				{
					name: "绑定手机",
					type: "modulephone",
					icon: require("@/assets/page/icon/phone.png"),
				},
				{
					name: "列表导航",
					type: "modulelise",
					icon: require("@/assets/page/icon/liebiao.png"),
				},
				{
					name: "订单组",
					type: "orderimg",
					icon: require("@/assets/page/icon/dingdan.png"),
				},
				{
					name: "图标组",
					type: "moduleimg",
					icon: require("@/assets/page/icon/navBar.png"),
				},
				// {
				// 	name: "按钮组",
				// 	type: "modulebut",
				// 	icon: require("@/assets/page/icon/blank.png"),
				// },
				{
					name: "付费会员",
					type: "modulepay",
					icon: require("@/assets/page/icon/paidmember.png"),
				}
			],
		},
		{
			name: "基础组件",
			key: "media",
			data: [
				{
				  name: "余额",
				  type: "balance",
				  icon: require("@/assets/page/icon/balance.png"),
				},
				{
				  name: "积分",
				  type: "pointeroffline",
				  icon: require("@/assets/page/icon/pointeroffline.png"),
				},
				{
				  name: "标题栏",
				  type: "title",
				  icon: require("@/assets/page/icon/title.png"),
				},{
					name: "图片轮播",
					type: "banner",
					icon: require("@/assets/page/icon/banner.png"),
				},
				{
					name: "单图组",
					type: "image",
					icon: require("@/assets/page/icon/image.png"),
				},
				{
					name: "魔方",
					type: "window",
					icon: require("@/assets/page/icon/window.png"),
				},
				{
					name: "热区",
					type: "hotZone",
					icon: require("@/assets/page/icon/hotZone.png"),
				},

				// {
				//   name: "搜索框",
				//   type: "search",
				//   icon: require("@/assets/page/icon/search.png"),
				// },
				// {
				// 	name: "金刚区",
				// 	type: "navBar",
				// 	icon: require("@/assets/page/icon/navBar.png"),
				// },
				{
					name: "商品组",
					type: "goods",
					icon: require("@/assets/page/icon/goods.png"),
				},
				// {
				// 	name: "标题栏",
				// 	type: "title",
				// 	icon: require("@/assets/page/icon/title.png"),
				// },
				{
					name: "富文本",
					type: "richText",
					icon: require("@/assets/page/icon/richText.png"),
				},
				{
					name: "辅助空白",
					type: "blank",
					icon: require("@/assets/page/icon/blank.png"),
				},
				{
					name: "辅助线",
					type: "guide",
					icon: require("@/assets/page/icon/guide.png"),
				},
			],
		},
		// {
		// 	name: "功能组件",
		// 	key: "other",
		// 	data: [{
		// 			name: "在线客服",
		// 			type: "service",
		// 			icon: require("@/assets/page/icon/service.png"),
		// 		},
		// 		{
		// 			name: "百问百答",
		// 			type: "article",
		// 			icon: require("@/assets/page/icon/article.png"),
		// 		},

		// 		{
		// 			name: "消息通知",
		// 			type: "notice",
		// 			icon: require("@/assets/page/icon/notice.png"),
		// 		},

		// 		{
		// 			name: "辅助线",
		// 			type: "guide",
		// 			icon: require("@/assets/page/icon/guide.png"),
		// 		},
		// 	],
		// },
	];
	import {
		eltips
	} from "@/util/util.js";
	export default {

		data() {
			return {
				// componentKeys: [0, 1, 2],
				Icon,
				data,
			};
		},
		computed: {
			// componentKeys() {
			//   const { data } = this;
			//   return data.map((item) => item.key);
			// },
		},
		methods: {
			handleClickItem(type, status) {
				if (status) {
					eltips('组件开发中', "error");
					return false
				}
				this.$emit("handleClickItem", type);
			},
		},
	};
</script>
<style lang="less" scoped>
object {
  /* 直接在CSS中设置 */
  --color: red; /* 这里定义一个CSS变量 */
}
::-webkit-scrollbar {
  width: 0;
  height: 0;
}
::v-deep .el-collapse {
  border-top: 0 !important;
  border-bottom: 0 !important;
}
::v-deep .el-collapse-item__header {
  padding-left: 32px;
  padding-right: 10px;
  font-weight: bold;
  position: relative;
}
::v-deep .el-collapse-item__arrow {
  position: absolute;
  left: 12px;
}
// 组件库
.components {
  width: 320px;
  // background: #f8f9fa;
  height: 100%;
  background: #ffffff;
  overflow-y: auto;
  border-radius: 6px;

  /deep/.ant-collapse-header {
    padding: 14px 16px;
    font-size: 14px;
    font-weight: 700;
    color: #595961;
  }

  /deep/.ant-collapse-content-box {
    padding-top: 0 !important;
  }

  /deep/.ant-collapse > .ant-collapse-item {
    border-bottom: none;
  }

  .module-list {
    display: flex;
    flex-wrap: wrap;
    margin-left: 10px;
  }

  .module-item {
    width: 77px;
    height: 77px;
    padding: 20px 0;
    text-align: center;
    font-size: 13px;
    color: #595961;
    line-height: 20px;
    position: relative;
    user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: rgba(0, 106, 255, 0.03);
    margin: 10px;
    border-radius: 5px;
    border: 1px solid rgba(0, 106, 255, 0) ;
	font-weight: bold;
    &:hover {
      // background: #f7f7f7;
      border-radius: 4px;
      color: #006aff;
      border: 1px solid #006aff !important;
      font-weight: bold;
    }
    .module-icon {
      position: relative;
      font-weight: 300;
      // left: -400px;
      // filter: drop-shadow( #006AFF 400px 0);
      // filter: invert(100%) sepia(96%) saturate(3726%) hue-rotate(336deg) brightness(99%) contrast(102%); /* 换成你想要的颜色 */
    }
    // .module-icon{
    // 	left: -500px;
    // 	filter: drop-shadow(#2067ad 500px 0) !important;
    // }
    .module-icon {
      display: block;
      width: 25px;
      height: 25px;
      line-height: 30px;
      margin: 0 auto 5px auto;
      // color: #9797a1;
      // opacity: 0.5;
    }
  }
}
.group_title {
  font-size: 14px;
  font-weight: 600;
  padding: 0px 15px 5px;
}
.module_box:nth-child(n+2) .group_title{
    margin-top: -2px;
    // background: red;
  }
.module_box:nth-child(1) .group_title{
    margin-top: 15px;
    // background: rgb(4, 0, 255);
  }
// 修改不要下划线
/deep/.el-collapse-item__wrap {
  border-bottom: none;
}
/deep/.el-collapse-item__header {
  border-bottom: none;
}
</style>